import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTrips } from '../../hooks/useTrips';
import { useVehicles } from '../../hooks/useVehicles';
import { formatDate, formatCurrency } from '../../utils/formatters';
import Badge from '../common/Badge';
import Table from '../common/Table';

const todayIso = () => new Date().toISOString().split('T')[0];

export default function RecentTrips({ vehicleId, isDriver, scopeToday = false }) {
  const { handleDriverScopeError } = useVehicles();
  const { trips, loading, loadTrips } = useTrips(vehicleId, (err) => {
    if (isDriver) handleDriverScopeError(err);
  });
  const tripRows = Array.isArray(trips) ? trips : Array.isArray(trips?.results) ? trips.results : [];

  useEffect(() => {
    if (scopeToday && !isDriver) {
      const today = todayIso();
      loadTrips({ start_date: today, end_date: today });
      return;
    }
    loadTrips();
  }, [vehicleId, scopeToday]);

  const cols = [
    { key: 'date', label: 'Date', render: (v) => formatDate(v) },
    { key: 'route', label: 'Route' },
    { key: 'declared_amount', label: 'Revenue', render: (v) => <span className="mono-number">{formatCurrency(v)}</span>, tdStyle: { textAlign: 'right' } },
    { key: 'total_expenses', label: 'Expenses', render: (v) => <span className="mono-number">{formatCurrency(v)}</span>, tdStyle: { textAlign: 'right' } },
    { key: 'profit', label: 'Profit', render: (v) => <span className={`mono-number ${v >= 0 ? '' : 'text-danger'}`} style={{ color: v >= 0 ? 'var(--success)' : 'var(--danger)' }}>{formatCurrency(v)}</span>, tdStyle: { textAlign: 'right' } },
    { key: 'status', label: 'Status', render: (v) => <Badge status={v} label={v} /> },
  ];

  if (isDriver) cols.splice(0, 0, { key: 'vehicle_reg', label: 'Vehicle' });

  return (
    <div className="card">
      <div className="card-header">
        <h3 style={{ margin: 0, fontFamily: 'var(--font-display)' }}>Recent Trips</h3>
        <Link to="/trips" className="btn btn-secondary btn-sm">View all</Link>
      </div>
      <Table columns={cols} data={tripRows.slice(0, 8)} loading={loading} emptyMessage="No trips recorded yet" />
    </div>
  );
}